module.exports = __webpack_public_path__ + "static/media/louis.ce017184.jpeg";